import { Injectable } from '@angular/core';

import { ConfigParserService } from './config-parser.service';

/**
 * Config for headers appended to requests.
 */
export interface OfficeHomeApiConfig {
    authTypeHeader: string;
    authVersionHeader: string;
    correlationIdHeader: string;
    defaultTimeoutInMs: number;
    externalTrafficHeader: string;
    featureOverrides: string;
    featureOverridesParamName: string;
    flightOverrides: string;
    flightOverridesParamName: string;
    jwtAuthEnabled: boolean;
    jwtAuthOnOfficeHome: boolean;
    mockRequestHeader: string;
    tenantIdHeader: string;
    testTrafficHeader: string;
    userIdHeader: string;
    workloadQueryParameter: string;
}

@Injectable({
    providedIn: 'root'
})
export class OfficeHomeApiConfigService  {
    public readonly config: OfficeHomeApiConfig;

    constructor(configParserService: ConfigParserService) {
        // Initialize to default values if there was failure to read user context from page response
        this.config = configParserService.parse<OfficeHomeApiConfig>('officeHomeApiConfig') || {
            authTypeHeader: null,
            authVersionHeader: null,
            correlationIdHeader: null,
            defaultTimeoutInMs: 300000,
            externalTrafficHeader: null,
            featureOverrides: null,
            featureOverridesParamName: null,
            flightOverrides: null,
            flightOverridesParamName: null,
            jwtAuthEnabled: false,
            jwtAuthOnOfficeHome: false,
            mockRequestHeader: null,
            tenantIdHeader: null,
            testTrafficHeader: null,
            userIdHeader: null,
            workloadQueryParameter: null
        };
    }
}
